import styled from 'styled-components';

export const AccountCredentialsContainer = styled.div`
  width: 50%;
`;
